var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-datepicker',{staticClass:"date-picker",attrs:{"required":"","value-as-date":"","locale":"en","date-format-options":{ month: '2-digit', year: 'numeric', day: '2-digit' },"value":_vm.date},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }